// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__2M8TU","col":"styles_col__3KjTU"};